import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { LineVolumeChart, LineMarkerChart } from 'ui-kit';
const chartPropsAreEqual = (prevProps, nextProps) => {
    var _a, _b;
    if (prevProps.isDark !== nextProps.isDark || prevProps.isLoading !== nextProps.isLoading) {
        return false;
    }
    if (((_a = prevProps.data) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = nextProps.data) === null || _b === void 0 ? void 0 : _b.length)) {
        return false;
    }
    if (prevProps.data && nextProps.data) {
        for (let i = 0; i < prevProps.data.length; i++) {
            const prevItem = prevProps.data[i];
            const nextItem = nextProps.data[i];
            const keys = Object.keys(prevItem);
            for (const key of keys) {
                if (prevItem[key] !== nextItem[key]) {
                    return false;
                }
            }
        }
    }
    return true;
};
const utilizationChartPropsAreEqual = (prevProps, nextProps) => {
    var _a, _b;
    if (prevProps.isDark !== nextProps.isDark || prevProps.isLoading !== nextProps.isLoading) {
        return false;
    }
    if (((_a = prevProps.data) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = nextProps.data) === null || _b === void 0 ? void 0 : _b.length)) {
        return false;
    }
    if (prevProps.data && nextProps.data) {
        for (let i = 0; i < prevProps.data.length; i++) {
            const prevItem = prevProps.data[i];
            const nextItem = nextProps.data[i];
            const keys = Object.keys(prevItem);
            for (const key of keys) {
                if (prevItem[key] !== nextItem[key]) {
                    return false;
                }
            }
        }
    }
    if (prevProps.currentMarker !== nextProps.currentMarker ||
        prevProps.optimalMarker !== nextProps.optimalMarker) {
        return false;
    }
    return true;
};
export const SupplyChart = React.memo(({ data, isDark, isLoading }) => (_jsx(LineVolumeChart, { data: data, chartType: "supply", title: "Supply APR", initialTimeframe: "1M", isDark: isDark, isLoading: isLoading })), chartPropsAreEqual);
export const BorrowChart = React.memo(({ data, isDark, isLoading }) => (_jsx(LineVolumeChart, { data: data, chartType: "borrow", title: "Borrow APR", initialTimeframe: "1M", isDark: isDark, isLoading: isLoading })), chartPropsAreEqual);
export const UtilizationChart = React.memo(({ data, currentMarker, optimalMarker, isDark, isLoading }) => (_jsx(LineMarkerChart, { data: data, title: "Utilization Rate", currentMarker: currentMarker, optimalMarker: optimalMarker, isDark: isDark, isLoading: isLoading })), utilizationChartPropsAreEqual);
SupplyChart.displayName = 'SupplyChart';
BorrowChart.displayName = 'BorrowChart';
UtilizationChart.displayName = 'UtilizationChart';
